/**
 * Tahsilatları yalnızca Arama Geçmişi görünümüne taşır. Bu satırlar arama
 * değerlendirmesi değildir; CD_DEG_REF/CD_DURUM_REF oluşturulmaz.
 */
export function buildPaymentHistoryRows(paraRows, satisRows, sabitRows, userRows) {
    const sabit = Array.isArray(sabitRows) ? sabitRows : [];
    const paraTypes = new Map(sabit
        .filter((row) => Number(row.ST_TUR) === 128)
        .map((row) => [Number(row.ST_KODINT), String(row.ST_AD || '').trim()]));
    const saleTypes = new Map(sabit
        .filter((row) => Number(row.ST_TUR) === 127)
        .map((row) => [Number(row.ST_KODINT), row.ST_AD || '']));
    const sales = new Map((Array.isArray(satisRows) ? satisRows : [])
        .map((row) => [Number(row.CAS_REF), row]));
    const users = new Map((Array.isArray(userRows) ? userRows : [])
        .map((row) => [Number(row.KUL_REF), row.KUL_ADI || '']));

    return (Array.isArray(paraRows) ? paraRows : [])
        .filter((row) => Math.abs(Number(row?.CP_TUTAR ?? row?.cp_tutar) || 0) > 0)
        .map((row) => {
            const cpRef = row?.CP_REF ?? row?.cp_ref;
            const cpCasRef = row?.CP_CAS_REF ?? row?.cp_cas_ref;
            const cpTur = row?.CP_TUR ?? row?.cp_tur;
            const cpTutar = row?.CP_TUTAR ?? row?.cp_tutar;
            const cpAck = row?.CP_ACK ?? row?.cp_ack;
            const sale = sales.get(Number(cpCasRef));
            const saleType = saleTypes.get(Number(sale?.CAS_TIP)) || '';
            const paymentType = paraTypes.get(Number(cpTur)) || '';
            const lowerType = paymentType.toLocaleLowerCase('tr-TR');
            const negative = lowerType.includes('iade') || lowerType.includes('anlaş') || lowerType.includes('anlas');
            const amount = Math.abs(Number(cpTutar) || 0) * (negative ? -1 : 1);
            const amountLabel = !paymentType ? 'Tutar' : (lowerType.endsWith('tutar') ? paymentType : `${paymentType} Tutar`);
            const formattedAmount = `${amount > 0 ? '+' : ''}${amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            const description = [saleType, `${amountLabel}: ${formattedAmount}`, cpAck]
                .filter((part) => String(part || '').trim().length > 0)
                .join(' - ');

            return {
                CD_REF: `PARA-${cpRef}`,
                CD_ARA_TAR: row?.CP_TAR ?? row?.cp_tar ?? null,
                CD_DEGERLENDIRME: paymentType || 'Ödeme türü belirtilmedi',
                SON_DURUM: '',
                CD_ACK: description || ' ',
                CD_VER_FIYAT: amount,
                CD_YETKILI: users.get(Number(row?.CP_MUS_TEM ?? row?.cp_mus_tem)) || '',
                _READ_ONLY_FROM_PARA: true,
                _PARA_REF: cpRef,
                _PARA_TUR_AD: paymentType,
                _PARA_TUTAR_LABEL: amountLabel
            };
        });
}

/** Ekrandaki iki ondalık basamakla tutarlı açık hesap uyarısı. */
export function hasOutstandingBalance(value) {
    const amount = Number(value);
    return Number.isFinite(amount) && Math.round((amount + Number.EPSILON) * 100) > 0;
}
